import { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getClientByCI } from './../../services/ClientService';
import { isValidEmail } from './../../utils/ValidatorUtils'

const AddClientModal = ({ open, onClose, onSave }) => {
  const { t } = useTranslation();

  const hasReasonableCIFormat = (ci) => {
    const cleaned = (ci || '').replace(/\D/g, '');
    return cleaned.length >= 6 && cleaned.length <= 8;
  };

  const [client, setClient] = useState({
    ci: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});

  const handleFieldChange = (field, value) => {
    setClient(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const handleBlurCI = async () => {
    if (client.ci) {
      try {
        const existingClient = await getClientByCI(client.ci);
        if (existingClient) {
          setClient(prev => ({
            ...prev,
            firstName: existingClient.firstName || '',
            lastName: existingClient.lastName || '',
            email: existingClient.email || '',
            phone: existingClient.phone || ''
          }));
        }
      } catch (error) {
        console.log('Cliente no encontrado o error al buscar:', error);
      }
    }
  };

  const validateFields = () => {
    const newErrors = {};

    if (!client.ci) {
      newErrors.ci = 'CI requerida';
    } else if (!hasReasonableCIFormat(client.ci)) {
      newErrors.ci = 'CI inválida';
    }

    if (!client.email) {
      newErrors.email = 'Correo requerido';
    } else if (!isValidEmail(client.email)) {
      newErrors.email = 'Correo inválido';
    }

    if (!client.firstName) {
      newErrors.firstName = 'Nombre requerido';
    }

    if (!client.lastName) {
      newErrors.lastName = 'Apellido requerido';
    }

    if (!client.phone) {
      newErrors.phone = 'Teléfono requerido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (validateFields()) {
      onSave(client);
      setClient({ ci: '', firstName: '', lastName: '', email: '', phone: '' });
      onClose();
    }
  };

  const handleClose = () => {
    setClient({ ci: '', firstName: '', lastName: '', email: '', phone: '' });
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{t('add_client')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {[
            ['ci', 'Cédula'],
            ['email', 'Correo'],
            ['firstName', 'Nombre'],
            ['lastName', 'Apellido'],
            ['phone', 'Teléfono']
          ].map(([field, label]) => (
            <Grid item xs={6} key={field}>
              <TextField
                label={label}
                fullWidth
                value={client[field]}
                onChange={e => handleFieldChange(field, e.target.value)}
                onBlur={field === 'ci' ? handleBlurCI : undefined}
                error={!!errors[field]}
                helperText={errors[field]}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddClientModal;
